import * as responses from './response';
import * as updates from './update';
var message = Object.assign({}, responses, updates);
var MessageFactory = (function () {
    function MessageFactory() {
    }
    MessageFactory.createMessage = function (msg) {
        if (!msg) {
            throw new Error("Could not create message because msg is \"" + msg + "\"");
        }
        if (!msg.Message || typeof msg.Message !== 'string') {
            throw new Error("Could not create message because msg.Message is \"" + msg.Message + "\"");
        }
        var separatorIdx = msg.Message.indexOf(MessageFactory.msgNameSeparator);
        if (separatorIdx === -1) {
            throw new Error("Could not create message for invalid msg.Message \"" + msg.Message + "\"");
        }
        try {
            var className = msg.Message.substr(separatorIdx + MessageFactory.msgNameSeparatorLength);
            if (message[className]) {
                return new message[className](msg);
            }
            else {
                return new responses.Mdg2Response(msg);
            }
        }
        catch (e) {
            throw new Error("Could not create message \"" + msg.Message + "\": " + e.message);
        }
    };
    MessageFactory.msgNameSeparator = '::';
    MessageFactory.msgNameSeparatorLength = 2;
    return MessageFactory;
}());
export { MessageFactory };
//# sourceMappingURL=MessageFactory.js.map